import us from '../public/lang/en-US.json'
import fr from '../public/lang/fr.json'
import it from '../public/lang/it-IT.json'

export const localizations = {
    "en-US": us,
    "fr": fr,
    'it-IT': it
}
